import React from 'react';
import './VitalSigns.css';

const VitalSigns = ({ vitalSigns, onChange }) => {
  const handleFieldChange = (field, value) => {
    onChange({
      ...vitalSigns,
      [field]: value
    });
  };

  const vitalSignsFields = [
    { key: 'peso', label: 'PESO', placeholder: 'kg' },
    { key: 'talla', label: 'TALLA', placeholder: 'cm' },
    { key: 'temperatura', label: 'TEMPERATURA', placeholder: '°C' },
    { key: 'tensionArterial', label: 'TENSIÓN ARTERIAL', placeholder: 'mmHg' },
    { key: 'frecuenciaCardiaca', label: 'FRECUENCIA CARDÍACA', placeholder: 'bpm' },
    { key: 'glicemia', label: 'GLICEMIA', placeholder: 'mg/dl' },
    { key: 'frecuenciaRespiratoria', label: 'FRECUENCIA RESPIRATORIA', placeholder: 'rpm' }
  ];

  return (
    <div className="vital-signs-section">
      <div className="vital-signs-title">SIGNOS VITALES</div>
      
      <div className="vital-signs-grid">
        {vitalSignsFields.map((field) => (
          <div key={field.key} className="vital-signs-field">
            <label htmlFor={field.key}>{field.label}</label>
            <input
              type="text"
              id={field.key}
              value={vitalSigns[field.key] || ''}
              onChange={(e) => handleFieldChange(field.key, e.target.value)}
              placeholder={field.placeholder}
              maxLength="20"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default VitalSigns;
